import { ManoExpressFreeMLogo } from '@/domains/core/tamagoshiTailwind/logos/manoExpress/ManoExpressFreeMLogo';

export const LocalizedFreeManoExpressDeliveryLogo = ({
  className,
}: {
  className?: string;
}) => <ManoExpressFreeMLogo className={className} />;
